(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 7314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(8228);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ LandingPage; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(6817);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/BackgroundImage/BackgroundImage.js
var BackgroundImage = __webpack_require__(9563);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Container/Container.js + 1 modules
var Container = __webpack_require__(2445);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Title/Title.js + 1 modules
var Title = __webpack_require__(9236);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(5117);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Group/Group.js + 2 modules
var Group = __webpack_require__(6137);
;// CONCATENATED MODULE: ./src/components/Hero/index.style.tsx

const useStyles = (0,create_styles/* createStyles */.k)((theme)=>({
        inner: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingBottom: 40
        },
        content: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "75%",
            textAlign: "center",
            [theme.fn.largerThan("lg")]: {
                width: "55%"
            },
            [theme.fn.smallerThan("md")]: {
                width: "100%",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center"
            }
        },
        groupButton: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            width: "100%",
            [theme.fn.smallerThan("sm")]: {
                justifyContent: "center",
                alignContent: "center"
            },
            [theme.fn.smallerThan("lg")]: {
                justifyContent: "center"
            }
        },
        title: {
            fontSize: 87,
            lineHeight: 0.8,
            fontWeight: 700,
            width: "100%",
            [theme.fn.smallerThan("xs")]: {
                fontSize: 35
            },
            [theme.fn.smallerThan("lg")]: {
                fontSize: 55
            }
        },
        TitleColor: {
            color: theme.colors.brand[4]
        },
        subtitle: {
            color: theme.colors.gray[8],
            fontSize: 20
        },
        image: {
            height: "100%",
            width: "100%",
            [theme.fn.smallerThan("md")]: {
                display: "none"
            }
        }
    }));

// EXTERNAL MODULE: ../../packages/fractif-ui/src/index.tsx + 65 modules
var src = __webpack_require__(7658);
;// CONCATENATED MODULE: ./src/components/Hero/index.tsx
"use client";



//Components

function Hero() {
    const { classes  } = useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.inner,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classes.content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title/* Title */.D, {
                            className: classes.title,
                            children: [
                                "The right way to invest in  ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: classes.TitleColor,
                                    children: "luxury."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            color: "dimmed",
                            mt: "md",
                            className: classes.subtitle,
                            children: "Collect tokens tied to luxury assets on Ethereum. Invest in fractions of luxury goods and diversify your portfolio."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                            mt: 30,
                            className: classes.groupButton,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* SecondaryButton */.kq, {
                                    title: "Discover"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* PrimaryButton */.KM, {
                                    title: "Invest"
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/ThemeIcon/ThemeIcon.js + 1 modules
var ThemeIcon = __webpack_require__(5044);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(2679);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Grid/Col/Col.js + 1 modules
var Col = __webpack_require__(9467);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/SimpleGrid/SimpleGrid.js + 2 modules
var SimpleGrid = __webpack_require__(9814);
// EXTERNAL MODULE: ../../node_modules/@tabler/icons/icons-react/dist/index.esm.js
var index_esm = __webpack_require__(4392);
;// CONCATENATED MODULE: ./src/components/Features/index.style.tsx

const index_style_useStyles = (0,create_styles/* createStyles */.k)((theme)=>({
        wrapper: {
            backgroundColor: theme.colors.brand[0]
        },
        title: {
            fontSize: 26,
            fontWeight: 800,
            lineHeight: 1.1,
            marginBottom: theme.spacing.md
        },
        featureDescription: {
            alignContent: "top",
            [theme.fn.smallerThan("xs")]: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "left"
            }
        },
        featureCard: {
            display: "flex",
            justifyContent: "left",
            gap: 10,
            [theme.fn.smallerThan("xs")]: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 20
            }
        }
    }));

;// CONCATENATED MODULE: ./src/components/Features/index.tsx
"use client";




const features = [
    {
        icon: index_esm/* IconWallet */.nr$,
        title: "Assets are stored in bank safes ",
        description: "By keeping the assets in bank safes, the Fractif Foundation will protect the assets until their sale has been decided by the tokens holders. We intend to protect the assets from theft, deterioration and other threats. A certificate of deposit will be uploaded on the IPFS for each product."
    },
    {
        icon: index_esm/* IconChartBar */.apE,
        title: "Make secure, trusty and … trades",
        description: "Our tokens use the leading industry ERC1155 standard and can be traded on Fractif, Opensea and many other legit marketplaces."
    },
    {
        icon: index_esm/* IconCircleDotted */.cCS,
        title: "Assets chosen and authenticated by professionals ",
        description: "We chose to work exclusively with brands and professionals to assure the authenticity of each item we will list on Fractif. A certificate of authenticity will be uploaded on the IPFS for each product."
    }
];
function FeaturesTitle() {
    const { classes  } = index_style_useStyles();
    const items = features.map((feature)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classes.featureCard,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeIcon/* ThemeIcon */.k, {
                    size: 44,
                    radius: "md",
                    variant: "gradient",
                    gradient: {
                        deg: 133,
                        from: "#0657CF",
                        to: "blue"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(feature.icon, {
                        size: 26,
                        stroke: 1.5
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classes.featureDescription,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            size: "lg",
                            pt: "0",
                            weight: 500,
                            style: {
                                width: "100%"
                            },
                            children: feature.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            color: "dimmed",
                            size: "sm",
                            pt: "xs",
                            children: feature.description
                        })
                    ]
                })
            ]
        }, feature.title));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid */.r, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* Col */.J, {
                        span: 12,
                        md: 6,
                        pb: "xl",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                            className: classes.title,
                            order: 2,
                            children: "Invest in secured, approved, and rare assets."
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* Col */.J, {
                        span: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleGrid/* SimpleGrid */.M, {
                            cols: 3,
                            spacing: 30,
                            breakpoints: [
                                {
                                    maxWidth: "md",
                                    cols: 1
                                }
                            ],
                            children: items
                        })
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Image/Image.js + 2 modules
var Image = __webpack_require__(2870);
;// CONCATENATED MODULE: ./public/discover-image.png
/* harmony default export */ var discover_image = ({"src":"/_next/static/media/discover-image.aa974ee4.png","height":461,"width":678,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAVFBMVEVMaXHP4/BLSZ5dbq1wZYTq7PKSl7i+4eZSXZB6favmvbTVn699e6vT4OI9SIKcqs0lR5rU8udncaZJTot0krI1fKaj0tidvNZ9f67Xzdq2ys9xmat/BMzuAAAAFnRSTlMA+NChCnL253ahap3CpMfo0rOK5cXRxaEHhAAAAAlwSFlzAAALEwAACxMBAJqcGAAAADJJREFUCJkFwQECQCAQAMGN03UiSin8/59mYHGqugOx38+bgXn446tAmFJopyCrbXYVfiKuAZ68s3FtAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/components/Discover/index.style.tsx

const Discover_index_style_useStyles = (0,create_styles/* createStyles */.k)((theme)=>({
        inner: {
            display: "flex",
            justifyContent: "space-between",
            paddingTop: theme.spacing.xl,
            paddingBottom: theme.spacing.xl,
            [theme.fn.smallerThan("md")]: {
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center"
            }
        },
        content: {
            maxWidth: 480,
            marginRight: theme.spacing.xl * 3,
            [theme.fn.smallerThan("md")]: {
                maxWidth: "100%",
                marginRight: 0
            }
        },
        title: {
            fontSize: 44,
            lineHeight: 1.2,
            fontWeight: 750,
            [theme.fn.smallerThan("xs")]: {
                fontSize: 28
            }
        },
        imageDesktop: {
            [theme.fn.smallerThan("md")]: {
                display: "none"
            }
        },
        imageMobile: {
            flex: 1,
            maxWidth: "100%",
            padding: theme.spacing.xl * 2,
            [theme.fn.largerThan("md")]: {
                display: "none"
            }
        },
        button: {
            paddingTop: theme.spacing.xl,
            [theme.fn.smallerThan("md")]: {
                paddingTop: theme.spacing.xl
            }
        }
    }));

;// CONCATENATED MODULE: ./src/components/Discover/index.tsx





function Discover() {
    const { classes  } = Discover_index_style_useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.inner,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                        src: discover_image.src,
                        className: classes.imageDesktop
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classes.content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                                className: classes.title,
                                children: "Invest in luxury, the best performing class of assets"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                src: discover_image.src,
                                className: classes.imageMobile
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                color: "dimmed",
                                mt: "md",
                                children: [
                                    "Diversifying your portfolio haven’t been more essential than today.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "It turns out that luxury assets have proven to be really good investments for quite a few years and the tendency seems to continue."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classes.button,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* PrimaryButton */.KM, {
                                    title: "Sign Up now"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/components/BannerCta/index.style.tsx

const BannerCta_index_style_useStyles = (0,create_styles/* createStyles */.k)((theme)=>({
        content: {
            maxWidth: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignContent: "center",
            [theme.fn.smallerThan("lg")]: {
                flexDirection: "column"
            }
        },
        description: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "right",
            alignItems: "end",
            textAlign: "right"
        },
        header: {
            display: "flex",
            justifyContent: "start",
            alignItems: "start",
            textAlign: "left",
            fontSize: 44,
            lineHeight: 1.2,
            fontWeight: 750,
            [theme.fn.smallerThan("xs")]: {
                fontSize: 28
            }
        },
        subtitle: {
            [theme.fn.smallerThan("lg")]: {
                maxWidth: "60%"
            },
            [theme.fn.smallerThan("md")]: {
                maxWidth: "100%"
            }
        },
        title: {
            [theme.fn.smallerThan("lg")]: {
                maxWidth: "80%"
            }
        },
        button: {
            paddingTop: theme.spacing.xl,
            [theme.fn.smallerThan("md")]: {
                paddingTop: theme.spacing.xl
            }
        }
    }));

;// CONCATENATED MODULE: ./src/components/BannerCta/index.tsx




function BannerCTA() {
    const { classes  } = BannerCta_index_style_useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.header,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                            className: classes.title,
                            children: "Discover, Invest, Resell and collect part of luxury goods"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classes.description,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                color: "dimmed",
                                mt: "md",
                                className: classes.subtitle,
                                children: "Have access to incredible objects that you would not have had access to without Fractif."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classes.button,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* PrimaryButton */.KM, {
                                    title: "Discover"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ../../node_modules/@mantine/hooks/esm/use-viewport-size/use-viewport-size.js
var use_viewport_size = __webpack_require__(7363);
;// CONCATENATED MODULE: ./src/components/Roadmap/index.style.tsx

const Roadmap_index_style_useStyles = (0,create_styles/* createStyles */.k)((theme)=>({
        wrapper: {
            backgroundColor: theme.colors.brand[0]
        },
        title: {
            fontSize: 87,
            fontWeight: 800,
            lineHeight: 1.1,
            marginBottom: theme.spacing.md,
            [theme.fn.smallerThan("md")]: {
                fontSize: 45
            }
        },
        subtitle: {
            [theme.fn.smallerThan("md")]: {
                fontSize: 12
            }
        },
        blueDot: {
            color: theme.colors.brand[4]
        },
        containerTitle: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "left"
        },
        cards: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center"
        },
        teamCard: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            alignItems: "start"
        },
        image: {
            width: "100%",
            height: "100%"
        }
    }));

// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(2809);
;// CONCATENATED MODULE: ./src/components/Roadmap/index.tsx
"use client";





function Roadmap() {
    const { classes , theme  } = Roadmap_index_style_useStyles();
    const { width  } = (0,use_viewport_size/* useViewportSize */.n)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.wrapper,
                id: "roadmap",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                    className: classes.containerTitle,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title/* Title */.D, {
                            className: classes.title,
                            children: [
                                "ROADMAP",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: classes.blueDot,
                                    children: "."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                            className: classes.subtitle,
                            children: [
                                "Detailled roadmap can be found ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: constants/* ROADMAP_URL */.LZ,
                                    style: {
                                        fontWeight: 800,
                                        textDecoration: "none",
                                        color: "black"
                                    },
                                    children: "here"
                                })
                            ]
                        })
                    ]
                })
            }),
            width > theme.breakpoints.md ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                    src: "./roadmap-desktop.svg",
                    alt: "roadmap"
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                    src: "./roadmap-mobile.svg",
                    alt: "roadmap"
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
;// CONCATENATED MODULE: ./src/components/Team/index.style.tsx

const Team_index_style_useStyles = (0,create_styles/* createStyles */.k)((theme)=>({
        wrapper: {
            backgroundColor: theme.colors.brand[0]
        },
        title: {
            fontSize: 87,
            fontWeight: 800,
            lineHeight: 1.1,
            marginBottom: theme.spacing.md,
            [theme.fn.smallerThan("md")]: {
                fontSize: 45
            }
        },
        blueDot: {
            color: theme.colors.brand[4]
        },
        containerTitle: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "left",
            alignItems: "center"
        },
        cards: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center"
        },
        teamCard: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            alignItems: "start"
        },
        image: {
            width: "100%",
            height: "100%"
        }
    }));

;// CONCATENATED MODULE: ./src/components/Team/index.tsx
"use client";



const TeamList = [
    {
        name: "Anthony",
        image: "https://cdn.discordapp.com/attachments/751483695214362704/1039530920086093864/1628083736914_1.png",
        job: "Founder & CTO"
    },
    {
        name: "Tom",
        image: "https://cdn.discordapp.com/attachments/751483695214362704/1039530920086093864/1628083736914_1.png",
        job: "Founder & Strategist"
    },
    {
        name: "T\xe9o",
        image: "https://cdn.discordapp.com/attachments/751483695214362704/1039530920086093864/1628083736914_1.png",
        job: "Founder & CTO"
    }
];
function Team() {
    const { classes  } = Team_index_style_useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.wrapper,
                id: "team",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                    className: classes.containerTitle,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title/* Title */.D, {
                        className: classes.title,
                        children: [
                            "THE TEAM",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: classes.blueDot,
                                children: "."
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                className: classes.cards,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleGrid/* SimpleGrid */.M, {
                    cols: 3,
                    spacing: 50,
                    breakpoints: [
                        {
                            maxWidth: "md",
                            cols: 1
                        }
                    ],
                    children: TeamList.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                            className: classes.teamCard,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                    className: classes.image,
                                    src: item.image,
                                    alt: item.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title/* Title */.D, {
                                    children: [
                                        item.name,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: classes.blueDot,
                                            children: "."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    children: item.job
                                })
                            ]
                        }, index))
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Accordion/Accordion.js + 17 modules
var Accordion = __webpack_require__(321);
;// CONCATENATED MODULE: ./public/faq.jpg
/* harmony default export */ var faq = ({"src":"/_next/static/media/faq.da347aed.jpg","height":2160,"width":2160,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAfEAABAwMFAAAAAAAAAAAAAAABAAIDBBEhBhNBUoH/xAAUAQEAAAAAAAAAAAAAAAAAAAAC/8QAFxEBAAMAAAAAAAAAAAAAAAAAAQARQf/aAAwDAQACEQMRAD8AoktRqdjrRUcTwZSblzcM3bDnpnxERJbyEK2f/9k=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/Ama/index.style.tsx

const Ama_index_style_useStyles = (0,create_styles/* createStyles */.k)((theme)=>({
        wrapper: {
            paddingTop: theme.spacing.xl * 2,
            paddingBottom: theme.spacing.xl * 2
        },
        title: {
            marginBottom: theme.spacing.md,
            paddingLeft: theme.spacing.md
        },
        item: {
            fontSize: theme.fontSizes.sm,
            color: theme.colorScheme === "dark" ? theme.colors.dark[1] : theme.colors.gray[7]
        },
        blueDot: {
            color: theme.colors.brand[4]
        },
        ctaDiscord: {
            paddingTop: theme.spacing.xl,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignContent: "center"
        },
        wrapperbannerComponent: {
            backgroundColor: theme.colors.brand[0]
        },
        titleBannerComponent: {
            fontSize: 87,
            fontWeight: 800,
            lineHeight: 1.1,
            marginBottom: theme.spacing.md,
            [theme.fn.smallerThan("md")]: {
                fontSize: 45
            }
        },
        containerBannerComponent: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "left",
            alignItems: "center"
        }
    }));

;// CONCATENATED MODULE: ./src/components/Ama/index.tsx





const Questionlist = [
    {
        key: "1",
        title: "What’s the goal of Fractif?",
        answer: "Take this Rolex Pepsi, if Alice wanted to buy only a fraction of it, let’s say 20$, she could either participate in the crowdsale or buy it from Bob on our marketplace."
    },
    {
        key: "2",
        title: "How can I purchase assets tokens?",
        answer: "Join our discord & newsletter to stay in touch and know about the upcoming assets."
    },
    {
        key: "3",
        title: "Where can I resell my tokens?",
        answer: "For the moment you can only resell your tokens via Opensea. Check the roadmap to be alerted of the release of Fractif marketplace."
    },
    {
        key: "4",
        title: "Do you sell luxury items?",
        answer: "No. We only sell fractions of a luxury asset that was divided programmatically in X tokens."
    },
    {
        key: "5",
        title: "Where do you keep assets tied to the tokens?",
        answer: "Assets are kept in bank safes. An independent custodian will publish Proof-of-Reserve each month."
    }
];
function Ama() {
    const { classes  } = Ama_index_style_useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.wrapperbannerComponent,
                id: "ama",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                    className: classes.containerBannerComponent,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title/* Title */.D, {
                        className: classes.titleBannerComponent,
                        children: [
                            "AMA",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: classes.blueDot,
                                children: "."
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                    size: "lg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid */.r, {
                        id: "faq-grid",
                        gutter: 50,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* Col */.J, {
                                span: 12,
                                md: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                    src: faq.src,
                                    alt: "Frequently Asked Questions"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* Col */.J, {
                                span: 12,
                                md: 6,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* Accordion */.U, {
                                        chevronPosition: "right",
                                        defaultValue: "reset-password",
                                        variant: "separated",
                                        children: Questionlist.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* Accordion.Item */.U.Item, {
                                                className: classes.item,
                                                value: item.key,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* Accordion.Control */.U.Control, {
                                                        children: item.title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* Accordion.Panel */.U.Panel, {
                                                        children: item.answer
                                                    })
                                                ]
                                            }, item.key))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classes.ctaDiscord,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* DiscordButton */.qD, {})
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Card/Card.js + 4 modules
var Card = __webpack_require__(1017);
;// CONCATENATED MODULE: ./src/components/BannerItems/index.style.tsx

const BannerItems_index_style_useStyles = (0,create_styles/* createStyles */.k)((theme)=>({
        containerWrapper: {
            maxWidth: "1800px",
            margin: "0 auto",
            display: "flex",
            flexDirection: "column"
        },
        card: {
            backgroundColor: theme.colors.brand[0],
            border: 0,
            height: "120px",
            width: "330px",
            minHeight: "120px",
            minWidth: "330px"
        },
        cardWrapper: {
            display: "flex",
            flexDirection: "row",
            gap: theme.spacing.xs,
            [theme.fn.smallerThan("md")]: {
                gap: theme.spacing.xs
            }
        },
        cardHeader: {
            color: theme.colors.sucess[2],
            display: "flex",
            justifyContent: "right",
            height: "25px"
        },
        cardTitle: {
            fontWeight: 600,
            fontSize: 22,
            lineHeight: 1
        },
        cardDescription: {
            fontWeight: 500,
            color: theme.colors.sucess[2]
        },
        cardImage: {},
        cardData: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignContent: "center",
            [theme.fn.smallerThan("md")]: {
                gap: theme.spacing.xs
            }
        },
        cardFirstRow: {
            display: "flex",
            flexDirection: "row",
            gap: theme.spacing.xl,
            justifyContent: "start",
            whiteSpace: "nowrap",
            overflowX: "hidden",
            [theme.fn.smallerThan("md")]: {
                gap: theme.spacing.md
            }
        },
        cardSecondRow: {
            display: "flex",
            flexDirection: "row",
            gap: theme.spacing.xl,
            justifyContent: "end",
            whiteSpace: "nowrap",
            overflowX: "hidden",
            [theme.fn.smallerThan("md")]: {
                gap: theme.spacing.md
            }
        }
    }));

;// CONCATENATED MODULE: ./public/itemBanner/Fractif_Banner_Rolex.png
/* harmony default export */ var Fractif_Banner_Rolex = ({"src":"/_next/static/media/Fractif_Banner_Rolex.cf5dc773.png","height":500,"width":500,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAP1BMVEVMaXGQkZHExcVoaWmys7PGxseDhISsra2ZmZmUlJWampq8vLw0NTVNTk2jo6O2t7dCQ0OmpqaPj49PT09kZWX12aVrAAAAEHRSTlMAtX6fx0ToIhP7e4L416vynCJxoQAAAAlwSFlzAABM5QAATOUBdc7wlQAAADdJREFUCJkli1kWABAMA2PfaXH/s6LyNS+ZAIAdAS9uziLQF3mpGlXKDwxtH8VJrMWB5f+CSnc5NF8BVBM0T84AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/itemBanner/Fractif_Banner_Hermes.png
/* harmony default export */ var Fractif_Banner_Hermes = ({"src":"/_next/static/media/Fractif_Banner_Hermes.c70b66ca.png","height":500,"width":500,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAKlBMVEUiIyhDQ0QcHiMXGB1WWGAtLjMXGR0bHCEqKy8lJysrLDIwMjcnKC0qKzCeNWBWAAAADnRSTlP+Av3+EFzmmEpvliI7gIS93+QAAAAJcEhZcwAATOUAAEzlAXXO8JUAAAA1SURBVAiZBcGHAcAwDMMwSl5Z/f/dAkiqJQkpUymRdWZmXy5A+PGwCS8WOExROCL42HR3c34glQD20yPt2wAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/itemBanner/Fractif_Banner_Ferrari.png
/* harmony default export */ var Fractif_Banner_Ferrari = ({"src":"/_next/static/media/Fractif_Banner_Ferrari.2ac745b4.png","height":500,"width":500,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAPFBMVEVMaXEAAACEhIQAAABYWFkaGhpfX19bW1sAAABgYGA0NTRJSkq4uLiXl5eJiYlcXFzW1tZ5eXhDQ0Nubm46ZhLOAAAAEnRSTlMAEbscUGur/jfyVveBHZQoQOoWNBXRAAAACXBIWXMAAEzlAABM5QF1zvCVAAAALUlEQVQImWNgwAT8LCy8IJpJmJ1dkI9HgIGNm5OdXUiIk4GBkZmDi5WVA1MTACO7AQACcYMtAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/itemBanner/Fractif_Banner_JaegerLeCoultre.png
/* harmony default export */ var Fractif_Banner_JaegerLeCoultre = ({"src":"/_next/static/media/Fractif_Banner_JaegerLeCoultre.95fe7539.png","height":500,"width":500,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAOVBMVEVMaXGIhoiGhYiqqKowNDwzN0BBREyUmaOgoqgyNj+6t7q3tbajo6iUk5ZQUlhCWnQ5Um5mdopqeYwQrifxAAAADHRSTlMAcYSKJDX0war9w65PytmCAAAACXBIWXMAAEzlAABM5QF1zvCVAAAANElEQVQImWNgYGBlY2NhAAEOXl5mMINdUIgDwhDgZ4cxICJcPDzcYAYTHx8jmMHKyQnUDgAq0QEvnqrFMQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/itemBanner/Fractif_Banner_Porsche.png
/* harmony default export */ var Fractif_Banner_Porsche = ({"src":"/_next/static/media/Fractif_Banner_Porsche.b6d9a794.png","height":500,"width":500,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAALVBMVEVMaXFgYmIAAAAwLy8AAAB5fXw5ODR1c3JmbWxiZWRiZWRMTU44NTV1dnRFREHs8CaSAAAADnRSTlMABBT4DkH5hyrl9dDVqQWNP80AAAAJcEhZcwAATOUAAEzlAXXO8JUAAAAzSURBVAiZTYs5EgAgCMQWkMvr/891KHRMlRQBAMKDyik0Kjx7z+WKaSZie4CYmVv7hssBGWQAr5iDuo8AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/itemBanner/Fractif_Banner_PatekPhilippe.png
/* harmony default export */ var Fractif_Banner_PatekPhilippe = ({"src":"/_next/static/media/Fractif_Banner_PatekPhilippe.8f1e8f11.png","height":500,"width":500,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAUVBMVEVMaXEyQlnS0MzPzsu9vLrW08+cnqPl5OO4trTBv7q4trXd2tezsrLDwsDc2tfu6+a2trZmdYfOzMqzsa9bbYHY19V9g4ySlJjW1NJze4aKjJFXb9kBAAAAFXRSTlMA/Cyk/Fv6BV4c8a3o48FrxPusq/qv/KBpAAAACXBIWXMAAEzlAABM5QF1zvCVAAAAP0lEQVQImRWLWRKAIBTDAgqCG2480Psf1OlfJ0kBv40JmEi9XmgdZtEDJT6n7UBozr2L3N2+NSsOvQ4C5Fn3H0pQAglLBycrAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/itemBanner/Fractif_Banner_AudemarsPiguet.png
/* harmony default export */ var Fractif_Banner_AudemarsPiguet = ({"src":"/_next/static/media/Fractif_Banner_AudemarsPiguet.af295713.png","height":500,"width":500,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAP1BMVEVMaXGSkZCqqql6enmFg4CxsbCWlpWnp6Z2dXO6urmWlpXR0tH////JyciPjYxCQD6wsK+ysbBsameenp1bWVZZdgTmAAAAEnRSTlMAynLl/gpA/v41gUoQaeD9j8cEJrYHAAAACXBIWXMAAEzlAABM5QF1zvCVAAAAPElEQVQImR2KSxbAIAwCUaPE1k8bvf9Z28gG3gwAIlnhecnHu4rYaAC6qcntROcO2V1Y6zrnSJYziqbffDW7AWVep/lPAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/itemBanner/Fractif_Banner_VanCleef.png
/* harmony default export */ var Fractif_Banner_VanCleef = ({"src":"/_next/static/media/Fractif_Banner_VanCleef.ff46fa2d.png","height":500,"width":500,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAKlBMVEVMaXHYwZ5tYl6HeWxpX12ah3ZjV1VpX1xpXVdaUlVsYVnGsZNQSUxlW1hM+32LAAAADnRSTlMAHG4bfEaBpmCOJAzqMwnfS7AAAAAJcEhZcwAATOUAAEzlAXXO8JUAAAAzSURBVAiZLYnHEQAgEITYC2b7b9fRkR8AYMFFspAg6rXaf2+G3kfM3DCaQ1+TsgAfme4cE70Av2VfsnoAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/itemBanner/Fractif_Banner_Macallan.png
/* harmony default export */ var Fractif_Banner_Macallan = ({"src":"/_next/static/media/Fractif_Banner_Macallan.f10a6c96.png","height":500,"width":500,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAP1BMVEVMaXE1NTU+Pj4zMzMtLS0WFhYNDQ0LCwtBQUE4ODgZGRk7OzsgICAvLy8xMTEkJCQoKChlZWVBQUFQUFBVVVWeTIjmAAAAEXRSTlMA6PJs/jD8Bd2xEdjUmZTdGKNr12gAAAAJcEhZcwAATOUAAEzlAXXO8JUAAAA3SURBVAiZLcZJFsAQEEDBbwhaBjT3P2teOmpVgHgfyJCd6mMpY91gmVe1rJiOL+fccfqHINI6LzrcAabV8zyGAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/BannerItems/index.tsx


//import icon trending-up

//import styles

//import all images









const ListItem = [
    {
        title: "Rolex",
        trending_percent: "+12,35%",
        image: Fractif_Banner_Rolex.src
    },
    {
        title: "Herm\xe8s",
        trending_percent: "+12,35%",
        image: Fractif_Banner_Hermes.src
    },
    {
        title: "Ferrari",
        trending_percent: "+12,35%",
        image: Fractif_Banner_Ferrari.src
    },
    {
        title: "Jaeger-leCoultre",
        trending_percent: "+12,35%",
        image: Fractif_Banner_JaegerLeCoultre.src
    },
    {
        title: "Macallan",
        trending_percent: "+12,35%",
        image: Fractif_Banner_Macallan.src
    },
    {
        title: "Patek Philippe",
        trending_percent: "+12,35%",
        image: Fractif_Banner_PatekPhilippe.src
    },
    {
        title: "Audemars Piguet",
        trending_percent: "+12,35%",
        image: Fractif_Banner_AudemarsPiguet.src
    },
    {
        title: "Van Cleef & Arpels",
        trending_percent: "+12,35%",
        image: Fractif_Banner_VanCleef.src
    },
    {
        title: "Porsche",
        trending_percent: "+12,35%",
        image: Fractif_Banner_Porsche.src
    }
];
function CardRendering(param) {
    let { item  } = param;
    const { classes  } = BannerItems_index_style_useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* Card */.Z, {
        p: "xl",
        radius: "md",
        className: classes.card,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card.Section */.Z.Section, {
                inheritPadding: true,
                py: "xs",
                className: classes.cardHeader,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconTrendingUp */.Wlf, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.cardWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.cardImage,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                            width: 75,
                            height: 75,
                            src: item.image
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classes.cardData,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                className: classes.cardTitle,
                                children: item.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                size: "xs",
                                className: classes.cardDescription,
                                children: item.trending_percent
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function BannerItems() {
    const { classes  } = BannerItems_index_style_useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.containerWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleGrid/* SimpleGrid */.M, {
                cols: 4,
                p: 10,
                className: classes.cardFirstRow,
                children: ListItem.slice(0, 5).map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(CardRendering, {
                        item: item
                    }, index))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleGrid/* SimpleGrid */.M, {
                cols: 4,
                p: 10,
                className: classes.cardSecondRow,
                children: ListItem.slice(4, 9).map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(CardRendering, {
                        item: item
                    }, index))
            })
        ]
    });
}

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Chip/Chip.js + 4 modules
var Chip = __webpack_require__(8602);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Slider/Slider/Slider.js + 14 modules
var Slider = __webpack_require__(345);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Badge/Badge.js + 1 modules
var Badge = __webpack_require__(7789);
;// CONCATENATED MODULE: ./src/components/Demo/index.style.tsx

const Demo_index_style_useStyles = (0,create_styles/* createStyles */.k)((theme)=>({
        wrapper: {
            height: "fit-content",
            borderRadius: "15px",
            padding: "20px",
            boxShadow: "0 10px 20px rgba(0,0,0,.1), 0 20px 40px rgba(0,0,0,.1)",
            [theme.fn.smallerThan("md")]: {
                height: "fit-content"
            }
        },
        macosRed: {
            backgroundColor: "#FF544D",
            width: "15px",
            height: "15px",
            borderRadius: "50%"
        },
        macosOrange: {
            backgroundColor: "#FEB429",
            width: "15px",
            height: "15px",
            borderRadius: "50%"
        },
        macosGreen: {
            backgroundColor: "#24C138",
            width: "15px",
            height: "15px",
            borderRadius: "50%"
        },
        cardData: {
            display: "flex",
            flexDirection: "column",
            alignContent: "center",
            gap: "20px",
            justifyContent: "center",
            width: "80%",
            [theme.fn.smallerThan("md")]: {
                width: "100%"
            }
        },
        cardBody: {
            display: "flex",
            height: "100%",
            padding: "35px",
            gap: 50,
            flexDirection: "row",
            [theme.fn.smallerThan("md")]: {
                flexDirection: "column"
            }
        },
        cardRightSection: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignContent: "center",
            [theme.fn.smallerThan("md")]: {
                display: "none"
            }
        },
        cardChipSelector: {
            display: "flex",
            flexDirection: "row"
        },
        cardTitleSection: {
            display: "flex",
            flexDirection: "row",
            alignContent: "center",
            gap: "10px",
            [theme.fn.smallerThan("xl")]: {
                flexDirection: "column"
            }
        },
        cardCalculatorSection: {
            display: "flex",
            flexDirection: "column"
        },
        cardRoiSection: {
            display: "flex",
            flexDirection: "column",
            alignContent: "center",
            justifyContent: "center",
            paddingTop: "60px"
        },
        subtitle: {
            textAlign: "center",
            color: theme.colors.gray[6],
            [theme.fn.smallerThan("md")]: {
                fontSize: "14px"
            }
        },
        sectionTitle: {
            fontWeight: 500,
            color: theme.colors.gray[6]
        },
        roiCard: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignContent: "center",
            gap: "10px",
            color: theme.colors.brand[4],
            fontWeight: 700
        },
        estimatedCashoutPercent: {
            display: "flex",
            justifyContent: "end",
            alignContent: "end"
        },
        roiDollars: {
            width: "fit-content",
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            justifySelf: "center",
            alignSelf: "center",
            backgroundColor: theme.colors.sucess[2],
            color: "white",
            [theme.fn.smallerThan("md")]: {
                fontSize: "14px"
            }
        },
        cardImage: {
            alignSelf: "center",
            justifySelf: "center",
            [theme.fn.smallerThan("md")]: {
                width: "80%"
            }
        },
        CardTitle: {
            [theme.fn.smallerThan("md")]: {
                fontSize: "28px"
            }
        },
        roiPart1: {
            fontSize: 52
        },
        roiPart2: {
            fontSize: 32
        }
    }));

;// CONCATENATED MODULE: ./public/demo/watch.png
/* harmony default export */ var watch = ({"src":"/_next/static/media/watch.cf5dc773.png","height":500,"width":500,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAP1BMVEVMaXGQkZHExcVoaWmys7PGxseDhISsra2ZmZmUlJWampq8vLw0NTVNTk2jo6O2t7dCQ0OmpqaPj49PT09kZWX12aVrAAAAEHRSTlMAtX6fx0ToIhP7e4L416vynCJxoQAAAAlwSFlzAABM5QAATOUBdc7wlQAAADdJREFUCJkli1kWABAMA2PfaXH/s6LyNS+ZAIAdAS9uziLQF3mpGlXKDwxtH8VJrMWB5f+CSnc5NF8BVBM0T84AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/demo/bag.png
/* harmony default export */ var bag = ({"src":"/_next/static/media/bag.c70b66ca.png","height":500,"width":500,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAKlBMVEUiIyhDQ0QcHiMXGB1WWGAtLjMXGR0bHCEqKy8lJysrLDIwMjcnKC0qKzCeNWBWAAAADnRSTlP+Av3+EFzmmEpvliI7gIS93+QAAAAJcEhZcwAATOUAAEzlAXXO8JUAAAA1SURBVAiZBcGHAcAwDMMwSl5Z/f/dAkiqJQkpUymRdWZmXy5A+PGwCS8WOExROCL42HR3c34glQD20yPt2wAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/demo/car.png
/* harmony default export */ var car = ({"src":"/_next/static/media/car.b6d9a794.png","height":500,"width":500,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAALVBMVEVMaXFgYmIAAAAwLy8AAAB5fXw5ODR1c3JmbWxiZWRiZWRMTU44NTV1dnRFREHs8CaSAAAADnRSTlMABBT4DkH5hyrl9dDVqQWNP80AAAAJcEhZcwAATOUAAEzlAXXO8JUAAAAzSURBVAiZTYs5EgAgCMQWkMvr/891KHRMlRQBAMKDyik0Kjx7z+WKaSZie4CYmVv7hssBGWQAr5iDuo8AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/Demo/index.tsx




//import styles

//import assets



//import icons

const ItemDemoList = [
    {
        type: "watches",
        item: "Rolex GMT-Master II Pepsi",
        asset: watch.src,
        roi: 23.06
    },
    {
        type: "bags",
        item: "Herm\xe8s Birkin 35 handbag",
        asset: bag.src,
        roi: 15.62
    },
    {
        type: "cars",
        item: "Porsche 911 Touring Pack",
        asset: car.src,
        roi: 8.75
    }
];
const beautifyPrice = (price)=>{
    return price.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
};
function calculateEstimatedCashout(item, price) {
    const estimatedCashout = item.roi / 100 * price;
    const fullCashout = estimatedCashout + price;
    return beautifyPrice(fullCashout);
}
function Demo() {
    const { classes , theme  } = Demo_index_style_useStyles();
    const { width  } = (0,use_viewport_size/* useViewportSize */.n)();
    const [demoItem, setDemoItem] = (0,react.useState)("watches");
    const [investAmount, setInvestAmount] = (0,react.useState)(50);
    const [itemData, setItemData] = (0,react.useState)(ItemDemoList.find((item)=>item.type === demoItem));
    (0,react.useEffect)(()=>{
        setItemData(ItemDemoList.find((item)=>item.type === demoItem));
    }, [
        demoItem
    ]);
    //TODO: Fix Box ROI 
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        id: "roi-calculator",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classes.wrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                className: classes.macosRed
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                className: classes.macosOrange
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                className: classes.macosGreen
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classes.cardBody,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classes.cardData,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classes.cardTitleSection,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                                                    className: classes.CardTitle,
                                                    children: "ROI Calculator"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                    children: itemData === null || itemData === void 0 ? void 0 : itemData.item
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Chip/* Chip.Group */.A.Group, {
                                            className: classes.cardChipSelector,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* Chip */.A, {
                                                    value: "watches",
                                                    onClick: ()=>setDemoItem("watches"),
                                                    children: "Watches"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* Chip */.A, {
                                                    value: "bags",
                                                    onClick: ()=>setDemoItem("bags"),
                                                    children: "Bags"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* Chip */.A, {
                                                    value: "cars",
                                                    onClick: ()=>setDemoItem("cars"),
                                                    children: "Cars"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                width < theme.breakpoints.md ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classes.cardImage,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                        src: itemData === null || itemData === void 0 ? void 0 : itemData.asset,
                                        alt: itemData === null || itemData === void 0 ? void 0 : itemData.item
                                    })
                                }) : "",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classes.cardCalculatorSection,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                            className: classes.sectionTitle,
                                            children: "Investment Amount"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* Slider */.i, {
                                            pt: 10,
                                            label: (value)=>"$".concat(value),
                                            onChange: (value)=>setInvestAmount(value),
                                            defaultValue: 5000,
                                            step: 1,
                                            min: 50,
                                            max: 10002,
                                            marks: [
                                                {
                                                    value: 0,
                                                    label: "$50"
                                                },
                                                {
                                                    value: 10000,
                                                    label: "$10,000"
                                                }
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classes.cardRoiSection,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: classes.roiCard,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: classes.roiPart1,
                                                                    children: [
                                                                        itemData === null || itemData === void 0 ? void 0 : itemData.roi.toString().split(".")[0],
                                                                        ","
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: classes.roiPart2,
                                                                    children: [
                                                                        itemData === null || itemData === void 0 ? void 0 : itemData.roi.toString().split(".")[1],
                                                                        "%"
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: classes.estimatedCashoutPercent,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Badge/* Badge */.C, {
                                                                className: classes.roiDollars,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconArrowNarrowUp */.sHE, {
                                                                        size: 8,
                                                                        stroke: 2
                                                                    }),
                                                                    "$",
                                                                    calculateEstimatedCashout(itemData, investAmount)
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                    className: classes.subtitle,
                                                    children: "ROI from 2021 to 2022"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        width > theme.breakpoints.md ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classes.cardImage,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                src: itemData === null || itemData === void 0 ? void 0 : itemData.asset,
                                alt: itemData === null || itemData === void 0 ? void 0 : itemData.item
                            })
                        }) : ""
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Modal/Modal.js + 1 modules
var Modal = __webpack_require__(8090);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Input/Input.js + 11 modules
var Input = __webpack_require__(4151);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(7841);
;// CONCATENATED MODULE: ./src/components/NewsletterPopup/index.style.tsx

const NewsletterPopup_index_style_useStyles = (0,create_styles/* createStyles */.k)((theme)=>({
        popupContainer: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: 35
        },
        popupFooter: {
            display: "flex",
            flexDirection: "column",
            width: "100%",
            gap: 10
        },
        popupGroupBulletPoint: {
            width: "80%"
        },
        popupBulletPoint: {
            display: "flex",
            flexDirection: "row",
            gap: 10,
            fontSize: "14px"
        },
        popupInput: {
            width: "100%",
            borderRadius: 10,
            backgroundColor: theme.colors.brand[0]
        },
        popupButton: {
            width: "100%",
            height: "55px",
            fontSize: "16px"
        },
        popupTitle: {
            textAlign: "center",
            fontSize: "32px"
        },
        popupCheckIcon: {
            color: theme.colors.brand[4]
        }
    }));

// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var dist_index_esm = __webpack_require__(3955);
// EXTERNAL MODULE: ./node_modules/@mantine/notifications/esm/events.js + 1 modules
var events = __webpack_require__(3575);
;// CONCATENATED MODULE: ./src/components/NewsletterPopup/index.tsx






function NewsletterPopUp(param) {
    let { opened , setOpened  } = param;
    var ref;
    const { register , handleSubmit , formState: { errors  }  } = (0,dist_index_esm/* useForm */.cI)();
    const { classes  } = NewsletterPopup_index_style_useStyles();
    const NewsletterPopUp = {
        title: "Join more than 1,298 investors getting 1 articles every weeks",
        bulletPoints: [
            "Luxury investment analysis",
            "2 mins to read",
            "Early acess to incoming items",
            "Free, forever"
        ]
    };
    async function onSubmit(data) {
        try {
            const res = await fetch("/api/mailchimp", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    email_address: data.email,
                    status: "subscribed"
                })
            });
            if (res.status === 200) {
                (0,events/* showNotification */.c0)({
                    title: "Sucessfully subscribed",
                    message: "Hey welcome into the fractif team! \uD83D\uDD25",
                    color: "green",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconCheck */.NOm, {}),
                    autoClose: true
                });
                setOpened(false);
            } else {
                (0,events/* showNotification */.c0)({
                    title: "Error",
                    message: "Something went wrong",
                    color: "red",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconAlertCircle */.Ldj, {}),
                    autoClose: true
                });
            }
        } catch (error) {
            (0,events/* showNotification */.c0)({
                title: "Error",
                message: "Something went wrong",
                color: "red",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconAlertCircle */.Ldj, {})
            });
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
            centered: true,
            opened: opened,
            onClose: ()=>setOpened(false),
            size: "md",
            withCloseButton: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                className: classes.popupContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                        className: classes.popupTitle,
                        children: NewsletterPopUp.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                        className: classes.popupGroupBulletPoint,
                        children: NewsletterPopUp.bulletPoints.slice(0, 5).map((bulletPoint)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classes.popupBulletPoint,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconCheck */.NOm, {
                                        size: 24,
                                        stroke: 1.5,
                                        className: classes.popupCheckIcon
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        children: bulletPoint
                                    })
                                ]
                            }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                        onSubmit: handleSubmit(onSubmit),
                        style: {
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classes.popupFooter,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                                    ...register("email", {
                                        required: true,
                                        pattern: {
                                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                            message: "Invalid email address"
                                        }
                                    }),
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconMail */.haR, {}),
                                    className: classes.popupInput,
                                    size: "md",
                                    placeholder: "example@email.com"
                                }),
                                errors.email && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    style: {
                                        color: "red",
                                        alignSelf: "center"
                                    },
                                    children: (ref = errors.email) === null || ref === void 0 ? void 0 : ref.message
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    className: classes.popupButton,
                                    type: "submit",
                                    children: "Subscribe to our newsletter"
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/pages/index.tsx


//Import landing page components











const pages_useStyles = (0,create_styles/* createStyles */.k)(()=>({
        background_effect: {
            position: "absolute",
            top: 0,
            right: 0,
            zIndex: -1,
            width: "30%",
            height: "100%"
        },
        inner: {
            "WebkitTouchCallout": "none",
            "WebkitUserSelect": "none",
            "KhtmlUserSelect": "none",
            "MozUserSelect": "none",
            "msUserSelect": "none",
            "userSelect": "none"
        }
    }));
function LandingPage() {
    const { classes  } = pages_useStyles();
    const [showPopup, setShowPopup] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        const timer = setTimeout(()=>{
            setShowPopup(true);
        }, 25000);
        return ()=>clearTimeout(timer);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.inner,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsletterPopUp, {
                opened: showPopup,
                setOpened: setShowPopup
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundImage/* BackgroundImage */.X, {
                src: "/landing_effect.svg",
                className: classes.background_effect
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerItems, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Discover, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturesTitle, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Demo, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerCTA, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Roadmap, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Team, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Ama, {})
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [348,774,888,179], function() { return __webpack_exec__(7314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);